import { useState, useRef, useEffect } from 'react';
import { useSyncState } from 'shared/hooks/useSyncState';
import { useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from 'app/store';
import { setDrawerOpen, setHeaderTitle } from 'features/ui/model/uiSlice';
import { useDeleteCategoryMutation, useGetCategoriesQuery } from 'widgets/category/api/getCategoryApi';
import { DrawerCategory } from 'widgets/category/DrawerCategory';
import { TableContentForMechanic } from 'entities/table/ui/TableContentForMechanic';
import { Drawer, IconButton, Typography } from '@mui/material';
import { DrawerContent } from 'shared/ui/Drawer/DrawerStyles';
import CloseIcon from '@mui/icons-material/Close';
import { DrawerChangeCategory } from 'widgets/category/DrawerChangeCategory';

const fields = [
  {
    field: 'product_category_id',
    title: 'ID',
    width: '10%',
  },
  {
    field: 'title_kk',
    title: 'Наименование на казахском',
    width: '30%',
  },
  {
    field: 'title_ru',
    title: 'Наименование на русском',
    width: '30%',
  },
  {
    field: 'title_kg',
    title: 'Наименование на киргизском',
    width: '30%',
  },
  {
    field: 'title_uz',
    title: 'Наименование на узбекском',
    width: '30%',
  },
  {
    field: 'title_en',
    title: 'Наименование на английском',
    width: '30%',
  },
  {
    field: 'created_at',
    title: 'Дата создания',
    width: '30%',
  },
  {
    field: 'updated_at',
    title: 'Дата обновления',
    width: '30%',
  },
];

export const CategoryWidget = () => {
  const [drawerVariant, setDrawerVariant] = useState<{
    variant: 'create' | 'editCategory';
    title: string;
  }>({
    variant: 'create',
    title: 'Изменить данные',
  });

  const { isDrawerOpen } = useAppSelector((state) => state.ui);
  const dispatch = useAppDispatch();
  const { app_type } = useParams();
  const [pagination, setPagination] = useState<{
    page: number;
    count: number;
    search: string;
  }>({
    page: 1,
    count: 10,
    search: '',
  });
  const [isShowSearch, setIsShowSearch] = useState(false);
  const searchQuery = useSyncState('');
  const searchRef = useRef('');

  const handleSetSearch = (search: string) => {
    searchQuery.set(search);
    searchRef.current = search;
  };

  // type Filter = {
  //   name: number | '';
  //   status: number | '';
  // };

  // const [filter, setFilter] = useState<Filter>({
  //   name: '',
  //   status: '',
  // });

  const { data: categorList, isSuccess } = useGetCategoriesQuery({
    search: pagination.search,
    page: pagination.page,
    size: pagination.count,
    order: 1,
  });

  const categList = { item: [] as any };

  if (categorList) {
    categorList.map((item) => {
      categList.item.push({
        id: item.product_category_id,
        product_category_id: item.product_category_id,
        title_kk: item.title_kk,
        title_ru: item.title_ru,
        title_kg: item.title_kg,
        title_uz: item.title_uz,
        title_en: item.title_en,
        created_at: item.created_at,
        updated_at: item.updated_at,
      });
    });
  }

  const handleClearFilter = () => {
    //   setFilter({
    //     name: '',
    //     status: '',
    //   });
  };

  const handleClearSearch = () => {
    setIsShowSearch(false);
    searchQuery.set('');
    searchRef.current = '';
    setPagination((prev) => ({
      ...prev,
      search: '',
    }));
  };

  useEffect(() => {
    if (app_type) {
      dispatch(setHeaderTitle(app_type!.toUpperCase()));
    }
  }, [app_type]);

  const [deleteCategory] = useDeleteCategoryMutation();
  const handleDeleteCategory = (id: number) => {
    deleteCategory(id).then(() => {
      setTimeout(() => {
        window.location.reload();
      }, 2500);
    });
  };

  const [titKz, setTitKz] = useState('');
  const [titRu, setTitRu] = useState('');
  const [titKg, setTitKg] = useState('');
  const [titUz, setTitUz] = useState('');
  const [titEn, setTitEn] = useState('');
  const [categId, setCategId] = useState(0);

  const handleDrawerEdit = (id: number) => {
    setDrawerVariant({
      variant: 'editCategory',
      title: 'Измененить категорию',
    });
    dispatch(setDrawerOpen(true));

    categList.item.map((c: any) => {
      if (c.id === id) {
        setTitKz(c.title_kk);
        setTitRu(c.title_ru);
        setTitKg(c.title_kg);
        setTitUz(c.title_uz);
        setTitEn(c.title_en);
        setCategId(id);
      }
    });
  };

  const onDrawerClose = () => {
    dispatch(setDrawerOpen(false));
    setDrawerVariant({ variant: 'create', title: '' });
  };

  return (
    <>
      {isSuccess ? (
        <TableContentForMechanic
          title="Список категории"
          fields={fields}
          list={{ list: categList.item }}
          count={categList.item.length}
          page={pagination.page - 1}
          perPage={pagination.count}
          onPageChange={(_, page) => {
            setPagination((prev) => ({
              ...prev,
              page: page + 1,
            }));
          }}
          onRowsPerPageChange={(e) => {
            setPagination(() => ({
              page: 1,
              count: parseInt(e.target.value),
              search: pagination.search,
            }));
          }}
          isShowSearch={isShowSearch}
          onShowSearch={(showSearch) => setIsShowSearch(showSearch)}
          onClearSearch={handleClearSearch}
          onClearFilter={handleClearFilter}
          search={searchQuery.get()}
          setSearch={handleSetSearch}
          onRowClick={() => {}}
          onDeleteClick={handleDeleteCategory}
          onChangeClick={handleDrawerEdit}
        />
      ) : (
        false
      )}
      <Drawer
        anchor="right"
        open={isDrawerOpen}
        onClose={onDrawerClose}
      >
        <DrawerContent>
          <div className="header">
            <Typography
              variant="h5"
              sx={{ fontWeight: '600' }}
            >
              {drawerVariant.title}
            </Typography>
            <IconButton
              onClick={onDrawerClose}
              sx={{ color: '#000' }}
            >
              <CloseIcon />
            </IconButton>
          </div>
          <div className="content">
            {drawerVariant.variant === 'create' && <DrawerCategory />}

            {drawerVariant.variant === 'editCategory' && (
              <DrawerChangeCategory
                categoryId={categId}
                title_en={titEn}
                title_kg={titKg}
                title_kk={titKz}
                title_ru={titRu}
                title_uz={titUz}
              />
            )}
          </div>
        </DrawerContent>
      </Drawer>
    </>
  );
};
